import React, { useState, useEffect } from 'react';

const BlinkingDot = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(prev => !prev);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <span
      style={{
        height: '10px',
        width: '10px',
        backgroundColor: 'green',
        borderRadius: '50%',
        display: 'inline-block',
        visibility: visible ? 'visible' : 'hidden'
      }}
    ></span>
  );
};

export default BlinkingDot;
